'use client';

import { useEffect, useRef } from 'react';

const VIEW_COOLDOWN_MS = 30 * 60 * 1000;

function getStorageKey(contentId: number): string {
  return `enkini-view-${contentId}`;
}

function readTimestamp(contentId: number): number | null {
  try {
    const raw = localStorage.getItem(getStorageKey(contentId));
    if (!raw) return null;
    const ts = parseInt(raw, 10);
    return isNaN(ts) ? null : ts;
  } catch {
    return null;
  }
}

function writeTimestamp(contentId: number): void {
  try {
    localStorage.setItem(getStorageKey(contentId), String(Date.now()));
  } catch {
  }
}

export function ViewTracker({
  contentId,
}: {
  contentId: number;
}) {
  const sentRef = useRef(false);

  useEffect(() => {
    if (sentRef.current) return;
    sentRef.current = true;

    const lastTs = readTimestamp(contentId);
    if (lastTs && Date.now() - lastTs < VIEW_COOLDOWN_MS) return;

    const controller = new AbortController();

    fetch(`/api/content/${contentId}/view`, {
      method: 'POST',
      signal: controller.signal,
    })
      .then((res) => {
        if (!res.ok) return;
        return res.json() as Promise<{ counted: boolean; views: number }>;
      })
      .then((data) => {
        if (data && data.counted) {
          writeTimestamp(contentId);
        }
      })
      .catch(() => {
      });

    return () => controller.abort();
  }, [contentId]);

  return null;
}
